/**
 * One stored Ask thread (block 17) — what a reload renders. `null` while the
 * page is still on a new thread that has no ID yet.
 */
import { useQuery } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useAskThread(id) {
    return useQuery({
        queryKey: queryKeys.ask.thread(id ?? ""),
        queryFn: () => getNookClient().getAskThread(id),
        enabled: id !== null,
        // A 404 is a thread that is not the caller's, not a blip.
        retry: (failureCount, error) => !(error instanceof Error && "status" in error && error.status === 404) &&
            failureCount < 2,
    });
}
//# sourceMappingURL=use-ask-thread.js.map